<template>
    <a :href="href" :aria-controls="name" role="tab" data-toggle="tab">
        <slot></slot>
    </a>
</template>

<script type="text/babel">
export default {
    props: ['href'],
    computed: {
        name() {
            return this.href.substring(1)
        },
    },
    methods: {
        open() {
            window.location.href = '#/' + this.name
        },
    },
}
</script>
